<mat-card>
    <mat-card-content style="height: max-content;">
        <ul class="connected-dots1"  > <li ><h3><img src="assets/images/meter.png" height="5%" width="5%">{{Deviceid}} Main Energy Meter</h3></li></ul>
                <div class="block-container"  style="overflow: auto;"  >
    <div class="block" *ngFor="let ar of energyMeterIdArray">
        <b style="margin-left: 5px;  white-space: nowrap; ">{{ar[0].floor}}</b>
        <div class="line">
            <ul class="connected-dots" *ngFor="let ar1 of ar">
                <li class="custom-tooltip"
                 (mouseenter) = "getAlertDataOnHover(ar1)"
                   [matTooltip]="dataTooltip"
                   style="white-space:pre-wrap;"
                    [ngStyle]="{'color': ar1.alert >= 1 ? 'red': ar1.alert < 1 ?'green':'black'}" >
                    <span [ngClass]="{'blinkr':ar1.alert>=1,'blink':ar1.alert < 1 }" >&#9673;</span> {{ar1.meterid}}({{ar1.meterName}})</li>
            </ul>
        </div>
                    </div>
                </div>
</mat-card-content>
</mat-card>









